import { Link } from 'react-router-dom';
import { Tooltip } from 'src/components/atoms';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const MenuTooltip = styled(Tooltip)`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${(props) =>
    props.theme.isVaultVariant
      ? `
    padding: 8px 16px;
    border-radius: 3px;
    box-shadow: ${props.theme.boxShadows.shadowSmall.boxShadow};
  `
      : `
    padding: ${props.theme.atlas.core.spacing[2]} ${props.theme.atlas.core.spacing[3]};
    border-radius: ${props.theme.atlas.semantic.radius.lg};
    box-shadow: ${props.theme.atlas.core.shadow.low};
    border: 1px solid ${props.theme.atlas.semantic.color.ui.divider.default};
  `}
`;

const linkStyling = `
  display: flex;
  align-items: center;
  gap: 14px;
  width: 230px;
  height: 54px;
  margin-left: -16px;
  padding-left: 16px;
`;

export const Title = styled.h4`
  ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newTypography.textStyleSubheading
      : textStyleCss(props.theme.atlas.typography.semantic.caption)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.atlas.semantic.color.type.default
      : props.theme.atlas.semantic.color.type.muted};
  /* Vault variant: match legacy textStyleSubheading — uppercase, bold, tracked */
  ${(props) =>
    props.theme.isVaultVariant &&
    `
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 1.5px;
  `}
`;

export const BodyText = styled.p`
  ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newTypography.textStyleBody
      : textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const Logout = styled.p`
  ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newTypography.textStyleBody
      : textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const ClickableNavigation = styled(Link)`
  ${linkStyling}
  text-decoration: none;

  &:hover {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N200
        : props.theme.atlas.core.color.gray[100]};
    cursor: pointer;
  }

  &:active {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.core.color.gray[400]};
  }
`;

export const ClickableContainer = styled.div`
  ${linkStyling}

  &:hover {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N200
        : props.theme.atlas.core.color.gray[100]};
    cursor: pointer;
  }

  &:active {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.core.color.gray[400]};
  }
`;
